import axios from "axios";
import { setTokenToRequest, handleInterceptors } from "../interceptor";
import { installDevcertInFlightProbe } from "./devcertInFlightProbe";
import qs from "qs";
import { TimeoutRequestConfigurationEnum } from "@/main/services/enum/TimeoutRequestConfigurationEnum";

const version = import.meta.env.VITE_API_VERSION;

const api = axios.create({
	baseURL: `${import.meta.env.VITE_API_BASE_URL}api/${version}/`,
	timeout: TimeoutRequestConfigurationEnum.Default,
	headers: {
		"Access-Control-Allow-Origin": "*",
	},
	paramsSerializer: (params) => {
		return qs.stringify(params, { arrayFormat: "repeat" });
	},
});

installDevcertInFlightProbe(api);

setTokenToRequest();
handleInterceptors();

const baseUrl = api.defaults.baseURL;

export { api, version, baseUrl };
